import styled from "styled-components";

export const PriceMainDiv = styled.div`
  position: relative;
`;

export const PriceHeaderSection = styled.div`
  text-align: center;
  align-items: center;
  position: relative;
  > div {
    display: content;
    > div {
      transform: translateX(-50%) rotate(180deg);
      -webkit-mask: linear-gradient(
          180deg,
          rgba(0, 0, 0, 0) 39%,
          rgba(0, 0, 0, 1) 63%
        )
        add;
      -webkit-user-select: none;
      flex: none;
      height: auto;
      left: 50%;
      mask: linear-gradient(180deg, rgba(0, 0, 0, 0) 39%, rgba(0, 0, 0, 1) 63%)
        add;
      opacity: 0.4;
      position: absolute;
      top: 0px;
      user-select: none;
      width: auto;
      z-index: 1;
      > div {
        align-items: center;
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        gap: 10px;
        height: min-content;
        justify-content: center;
        overflow: hidden;
        padding: 0;
        position: relative;
        width: min-content;

        mask: radial-gradient(
          80% 112%,
          rgba(0, 0, 0, 0) 0%,
          rgba(0, 0, 0, 0.4) 36%,
          rgb(0, 0, 0) 60%,
          rgba(0, 0, 0, 0) 100%
        );
        opacity: 1;
        border-radius: 38px;
        will-change: auto;
        > div {
          -webkit-user-select: none;
          flex: none;
          height: 535px;
          overflow: hidden;
          position: relative;
          user-select: none;
          width: 966px;
          opacity: 1;
          > div {
            -webkit-user-select: none;
            flex: none;
            height: 100%;
            left: calc(50.00000000000002% - 100% / 2);
            overflow: hidden;
            position: absolute;
            top: calc(49.906542056074784% - 100% / 2);
            user-select: none;
            width: 100%;
            
            opacity: 1;
            > div {
              position: absolute;
              border-radius: inherit;
              inset: 0px;
              > img {
                display: block;
                width: 966px;
                height: 535px;
                border-radius: inherit;
                object-position: center center;
                object-fit: cover;
              }
            }
          }
        }
      }
    }
  }

  margin: 0 auto;
  max-width: 966px;

  display: flex;
  flex: none;
  flex-direction: column;
  flex-wrap: nowrap;
  gap: 40px;
  height: min-content;
  justify-content: center;
  max-width: 966px;
  overflow: hidden;
  padding: 197px 0 0;
  position: relative;
  width: 100%;
  .section {
    align-content: center;
    align-items: center;
    display: flex;
    flex: 1 0 0px;
    flex-direction: column;
    flex-wrap: nowrap;
    gap: 16px;
    height: min-content;
    justify-content: center;
    max-width: 491px;
    padding: 0 0 80px;
    position: relative;

    z-index: 2;
  }
  .sub_text {
    flex: none;
    height: auto;
    opacity: 0.6;
    position: relative;
    white-space: pre;
    width: auto;
    outline: none;
    display: flex;
    flex-direction: column;
    justify-content: center;
    flex-shrink: 0;
    transform: none;
    > p {
      font-size: 18px;
      margin: 0;
      color: rgb(251, 251, 250);
      color: ;
    }
  }
  .sub_header {
    outline: none;
    display: flex;
    flex-direction: column;
    justify-content: center;
    flex-shrink: 0;
    transform: none;
    > h2 {
      font-size: 56px;
      line-height: 1em;
      margin: 0;
    }
  }
  @media (max-width: 480px) {
  .sub_header {
    
    > h2 {
      font-size: 40px;
      
    }
  }
  }
`;

export const PriceItems = styled.div`
  display: flex;
  align-items: top;
  justify-content: space-evenly;
  flex-wrap: wrap;
  gap: 90px;
  @media (max-width: 728px) {
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
`;
export const PricingCard = styled.div`
  align-content: flex-start;
  align-items: flex-start;
  display: flex;
  flex: 1 0 0px;
  flex-direction: column;
  flex-wrap: nowrap;
  min-width:200px;
  border-top: 1px solid rgb(58, 58, 58);
  width:33%;
  min-width:250px;
  
  justify-content: space-between;
  min-height: 490px;
  overflow: hidden;
  padding: 40px;
  position: relative;
  width: 1px;
  border-right: 1px solid rgb(58, 58, 58);
  .price_text{
  font-size:52px;
  font:weight:600;
  }
  .text{
   font-size:24px;
  font:weight:500;
  }
`;

interface PriceCardButtonProp {
  bg?: string;
  color?: string;
}

interface PriceCardSectionProp {
  color?: string;
  itemPos?: string;
  $isMonthly: boolean;

  justifyDivContent?: String;
}
export const PriceCardSection = styled.div<PriceCardSectionProp>`
  width: 90%;
  gap: 5px;

  font-size: 15px;
  display: flex;
  flex-direction: column;
  align-items: left;
  justify-content: ;
  max-width: 966px;
  margin: 0 auto;

  .button_wrap {
    border: 1px solid rgb(58, 58, 58);
    border-radius: 6px;
    display: flex;
    width: fit-content;
    margin: 0 auto;
    position: relative;
    margin: 0 auto 24px;

    &:before {
      content: "";
      position: absolute;
      width: ;
      height: 98%;
      left: ${(p) => (p.$isMonthly ? " .4px" : "86px")};
      width: ${(p) => (p.$isMonthly ? " 83px" : "150px")};
      top: 1%;
      border-radius: 6px;
      background:var(--sixth-gradient1);
      transition: all 0.4s;
    }

    > div {
      cursor: pointer;
      align-content: center;
      align-items: center;
      display: flex;
      flex: none;
      flex-direction: row;
      flex-wrap: nowrap;
      gap: 10px;
      height: min-content;
      justify-content: center;
      overflow: hidden;
      padding: 6px 14px;
      position: relative;
      width: min-content;
      white-space: nowrap;
    }
  }

  .price_container {
    align-content: flex-start;
    align-items: stretch;
    display: flex;
    flex: none;
    flex-direction: row;
    flex-wrap: wrap;
    gap: 0px;
    height: min-content;
    justify-content: center;
    max-width: 966px;
    overflow: visible;
    padding: 0;
    position: relative;
    width: 100%;
    border-left: 1px solid rgb(58, 58, 58);

    border-bottom: 1px solid rgb(58, 58, 58);
  }
`;

interface PriceCardIconProp {
  imgWidth?: string;
  imgHeight?: string;
  margin_left?: string;
}
export const PriceCardIcon = styled.img<PriceCardIconProp>`
  height: ${(p) => p.imgHeight || "24px"};
  width: ${(p) => p.imgWidth || "24px "};
`;

export const PriceCardButton = styled.div<PriceCardButtonProp>`
  height: 64px;
  width: 90%;
  border: 0.75px solid rgb(58, 58, 58);
  text-align: center;
  justify-content: center;
  text-transform: capitalize;
  display: flex;
  cursor: pointer;
  font-size: 1.5rem;
  align-items: center;
  background: rgb(12, 12, 12);

  transition: all 0.5s;
  &:hover {
    background-color: white;
    color: rgb(12, 12, 12);
  }
`;

export const PriceYearSection = styled.div<PriceCardSectionProp>`
  width: 90%;
  gap: 5px;
  padding: 0px 70px;
  font-size: 15px;
  display: block !important ;

  h5 {
    font-size: 32px;
    font-weight: 500;
    line-height: 48px;
    letter-spacing: 0em;
    text-align: center !important;
    text-transform: capitalize;

    margin: 0px;
  }
  .year {
    font-size: 16px;
    font-weight: 600;
    line-height: 33px;
    letter-spacing: 0em;
    text-align: left;
    color: #757575;
    text-decoration: none;
  }
  .cancled {
    text-decoration: line-through;
    text-decoration-color: white;
    color: #757575;
    font-size: 27px;
    padding-right: 10px;
  }

  @media (max-width: 728px) {
    padding: 0px;
  }
`;

export const PriceDurationSection = styled.div`
  align-content: flex-start;
  align-items: flex-start;
  display: flex;
  flex: none;
  flex-direction: column;
  flex-wrap: nowrap;
  gap: 4px;
  height: min-content;
  justify-content: flex-start;
  overflow: visible;
  padding: 0 0 12px;
  position: relative;
  width: 100%;
`;

interface PriceDurationSpanProp {
  active?: boolean;
}
export const PriceDurationSpan = styled.div<PriceDurationSpanProp>`
  font-size: 18px;
  font-weight: 900;
  padding: 7px;
  min-width: 70px;
  border-radius: 7px;
  marginl: 0;
  text-align: center;
  cursor: pointer;
  transition: all 0.4s;
  color: ${(p) => (p.active ? "white" : "black")};
  background: ${(p) => (p.active ? "rgb(23 2 43)" : "transparent")};
  box-shadow: ${(p) =>
    p.active
      ? "rgb(255, 255, 255) 0px 1px 1px 0px, rgb(255, 255, 255) 0px 1px 1px 1px"
      : "none"};
`;

export const PriceInfoSpan = styled.div`
  align-content: center;
  align-items: center;
  display: flex;
  flex: none;
  flex-direction: row;
  flex-wrap: nowrap;
  gap: 8px;
  height: min-content;
  justify-content: flex-start;
  overflow: visible;
  padding: 2px 0 1.5px;
  position: relative;
  width: 100%;
  svg {
    flex-shrink: 0;
  }

  p {
    font-size: 16px;
    font-weight: 400;
    margin: 0;
    text-align: left;
  }
`;
